import { mapValues } from 'radash';
import '../tokens/border-radiuses.js';
import '../tokens/colors.js';
import '../tokens/font-sizes.js';
import '../tokens/gaps.js';
import { heights } from '../tokens/heights.js';
import '../tokens/spacings.js';
import '../tokens/widths.js';

/**
 * A mapping between height tokens and their associated border radius values. This ensures visual
 * harmony between element size and curvature.
 */ const heightToBorderRadius = mapValues(heights, (_, token)=>token);

export { heightToBorderRadius };
//# sourceMappingURL=height-to-border-radius.js.map
